<template>
    <div class="message gallery-image-card" :key="'card-' + current">
        <div class="card" :class="{ selected: isSelected }">
            <div class="card-image" v-if="card.imageUrls && card.imageUrls.length > 0">
                <div class="image-wrapper">
                    <ssr-carousel
                        class="image-slider"
                        :loop="false"
                        :show-arrows="current"
                        :show-dots="current"
                        :slides-per-page="card.imageUrls.length > 4 ? 2 : 1"
                        :gutter="0"
                        :key="Math.random() * 100000"
                    >
                        <div class="slide" v-for="image of card.imageUrls" :key="image"><img :src="image" /></div>
                    </ssr-carousel>
                </div>
            </div>
            <div class="card-image" v-else-if="card.imageUrl">
                <div class="image-wrapper">
                    <img :src="card.imageUrl" />
                </div>
            </div>
            <div class="card-content">
                <div class="card-title">
                    {{ card.title }}
                </div>
                <div class="card-description" v-html="card.description" />
            </div>
            <div class="buttons">
                <div
                    v-for="(button, i) in card.buttons"
                    class="single-button"
                    :class="{ selected: isSelected && selectedButtonId === button.id }"
                    :key="button.id"
                    @click="
                        sendButtonMessage('GALLERY', {
                            cardId: card.id,
                            buttonId: button.id,
                            blockId,
                            payloadId,
                            buttonPayload: button.payload,
                            button: button,
                        })
                    "
                >
                    <div class="single-button-text" v-html="button.title" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sendSocketMessage } from "../../../../utils/socketStream";
import _ from "lodash";
import { mapState } from "vuex";
import Vue from "vue";
import SsrCarousel from "vue-ssr-carousel";
import ssrCarouselCss from "vue-ssr-carousel/index.css";

Vue.component("ssr-carousel", SsrCarousel);
export default {
    name: "GalleryImageCard",
    props: ["card", "current", "blockId", "payloadId", "conversationId", "isSelected", "selectedButtonId"],
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
        isReadOnly() {
            return !this.conversationId.startsWith("test-");
        },
    },
    data() {
        return {
            clickedButton: null,
        };
    },
    methods: {
        sendButtonMessage(type, payload) {
            if (this.isReadOnly) return;
            this.clickedButton = payload.buttonId;
            sendSocketMessage("chatbot/v2 test-user-button-select", {
                siteId: this.siteId,
                conversationId: this.conversationId,
                type,
                payload,
            });
        },
    },
};
</script>

<style lang="scss">
.message.gallery-image-card {
    margin: 0 8px;
    transition: opacity 0.3s;

    .card {
        border: 1px solid;
        border-radius: 10px;
        overflow: hidden;
        width: 240px;
        border-color: rgb(219, 225, 232);
        background: rgb(255, 255, 255);

        &.selected {
            border-color: rgba(0, 0, 0, 0.5);
        }

        .card-image {
            height: 180px;

            .image-slider,
            .ssr-carousel-slides,
            .slide {
                height: 170px;
                max-height: 170px;
            }

            .image-wrapper {
                height: 100%;
                width: 100%;

                img {
                    height: 100%;
                    object-fit: cover;
                    width: 100%;
                    background: transparent !important;
                    display: block;
                    max-width: 100%;
                }
            }
        }

        .card-content {
            display: flex;
            flex-direction: column;
            padding: 0 20px 30px;

            .card-title {
                word-wrap: break-word;
                font-size: 16px;
                font-weight: 600;
                line-height: 20px;
                margin-top: 12px;
                white-space: normal;
                width: 100%;
                color: rgb(0, 0, 0);
                margin-bottom: 0 !important;
            }

            .card-description {
                word-wrap: break-word;
                font-size: 16px;
                line-height: 20px;
                margin-top: 12px;
                white-space: normal;
                color: rgb(0, 0, 0);
            }
        }

        .buttons {
            display: flex;
            flex-direction: column;
            width: 100%;

            .single-button {
                align-items: center;
                border-top: 1px solid;
                cursor: pointer;
                display: flex;
                font-weight: 600;
                height: 45px;
                padding: 0 10px;
                transition: all 0.3s;
                background: rgb(255, 255, 255);
                border-top-color: rgb(219, 225, 232);

                &.selected {
                    opacity: 0.5;
                }

                &:hover {
                    opacity: 0.8 !important;
                }

                .single-button-text {
                    color: rgb(0, 108, 255);
                    overflow: hidden !important;
                    text-align: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                }
            }
        }
    }
}
</style>
